import { render, staticRenderFns } from "./CreateMenu.vue?vue&type=template&id=368cd071&scoped=true&"
import script from "./CreateMenu.vue?vue&type=script&lang=js&"
export * from "./CreateMenu.vue?vue&type=script&lang=js&"
import style0 from "./importer.css?vue&type=style&index=0&id=368cd071&scoped=true&lang=css&"
import style1 from "./CreateMenu.vue?vue&type=style&index=1&id=368cd071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368cd071",
  null
  
)

export default component.exports